import { Base64 } from "js-base64";

const BASEKEY = 'x0DE7'
function decodeFromBase64(base64Str_x0) {
  if (typeof base64Str_x0 !== 'string') {
    return base64Str_x0;
  }
  if( base64Str_x0.slice(0, BASEKEY.length) != BASEKEY){
    return base64Str_x0
  }
  const base64Str = base64Str_x0.slice(BASEKEY.length, base64Str_x0.length)
  try {
    const str = decodeURIComponent(decodeURI(Base64.atob(base64Str)));
    if(str && /^[\u{0020}-\u{D7FF}\u{E000}-\u{FFFF}]*$/u.test(str)){
        return str
    }else {
        return base64Str
    }
  } catch (e) {
   // 解码失败，返回原始字符串
   return base64Str;
  }
}

export default function pageData(url) {
    if (!url) return {
        'page_type_detail': 'other',
        'page_type': 'other',
    }
    function GetQueryString(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = decodeURIComponent(url.search).substr(1).match(reg);
        if (r != null) return unescape(r[2]); return null;
    }
    function get_campaign_code(campaign_code) {
        const arr = (campaign_code && campaign_code.split(/intcmp=|kwrec=|prodlink=/)) || []
        return arr.length > 1 ? arr[arr.length - 1] : null
    }
    const pageTMP = {
        "category": () => {
            const categoryId = url.pathname.split('/')[2];
            const category = categoryId.split('-')
            return {
                'page_type_detail': `category_list_${category.length}`,
                'page_type': 'List-page',
                'categoryId': url.pathname.split('/')[2] || ""
            }
        },
        "gift_set.html": () => {
            return {
                'page_type_detail': 'gift_list',
                'page_type': 'List-page',
            }
        },
        "function": () => {
            return {
                'page_type_detail': 'function_list',
                'page_type': 'List-page',
            }
        },
        'exclusive_product.html': () => {
            return {
                'page_type_detail': 'exclusive_list',
                'page_type': 'List-page',
            }
        },
        'search': () => {
            return {
                'page_type_detail': 'search_list',
                'page_type': 'List-page',
                'key_words': decodeFromBase64(GetQueryString('k')),
                'page_id': "WEB_1000311",
                'action_id': "1000311_000",
            }
        },
        'hot': () => {
            return {
                'page_type_detail': 'search_hot_list',
                'page_type': 'List-page',
                'key_words': decodeFromBase64(GetQueryString('k'))
            }
        },
        'brand': () => {
            const brand_id = url.pathname.split('/')[2] && url.pathname.split('/')[2].split('-')[1] || null
            const story = url.pathname.split('/')[2] && url.pathname.split('/')[2].split('-')[2] || null
            if (story) {
                return {
                    'page_type_detail': 'brand_story',
                    'page_type': 'Campaign-page',
                    'brand_id': story,
                    'page_id': "WEB_1000213",
                    'action_id': "1000213_000",
                }
            }
            if (brand_id) {
                return {
                    'page_type_detail': 'brand_list',
                    'page_type': 'List-page',
                    'brand_id': brand_id
                }
            }
            return {
                'page_type_detail': 'brand_navigation',
                'page_type': 'Navigation-page',
                'action_id': "1000212_000",
                'page_id': "WEB_1000212",
            }
        },
        'product': () => {
            return {
                'page_type_detail': 'product_detail',
                'page_type': 'Product-detail-page',
                'OP_code': url.pathname.split('/')[2].split('.')[0] || "",
                'page_id': "WEB_1000401",
                'action_id': "1000401_000",
            }
        },
        'resetPasswords': () => {
            return {
                'page_type_detail': 'myaccount_resetPasswords',
                'page_type': 'Function-page',
            }
        },
        'cart': () => {
            return {
                'page_type_detail': 'cart',
                'page_type': 'Function-page',
                'page_id': "WEB_1000411",
                'action_id': "1000411_000",
            }
        },
        'checkout': () => {
            return {
                'page_type_detail': 'checkout_order',
                'page_type': 'Function-page',
            }
        },
        'payment': () => {
            return {
                'page_type_detail': 'checkout_payment',
                'page_type': 'Function-page',
            }
        },
        'order': () => {
            return {
                'page_type_detail': 'order_detail',
                'page_type': 'Function-page',
                'orderID': url.pathname.replace(/\/order-|\.html/gi, '') || ""
            }
        },
        'myAccount': () => {
            const pagename = url.pathname.split('/')[2] || null
            const data = {
                'myCoupon': {
                    'page_type_detail': 'myAccount_coupon',
                    'page_type': 'Function-page',
                    'action_id': "1000611_000",
                    'page_id':"WEB_1000611"
                },
                'address': {
                    'page_type_detail': 'address',
                    'page_type': 'Function-page',
                },
                'management': {
                    'page_type_detail': 'myAccount-management',
                    'page_type': 'Function-page',
                },
                'integralFlow': {
                    'page_type_detail': 'myAccount-integralFlow',
                    'page_type': 'Function-page',
                    'page_id': "WEB_1000142",
                    'action_id': "1000142_000",
                },
                'myMemberCard': {
                    'page_type_detail': 'member_card',
                    'page_type': 'Function-page',
                    'page_id': "WEB_1000162",
                    'action_id': "1000162_000",
                },
                'modifyPassword': {
                    'page_type_detail': 'myAccount-modifyPassword',
                    'page_type': 'Function-page',
                },
                'changeHistory': {
                    'page_type_detail': 'myAccount-changeHistory',
                    'page_type': 'Function-page',
                    'page_id': "WEB_1000143",
                    'action_id': "1000143_000",
                },
                'issueInvoice': {
                    'page_type_detail': "myAccount-Invoice",
                    'page_type': "Function-page",
                    'action_id': "1000425_000",
                    'page_id':"WEB_1000425"
                },
                'profile.html': {
                    'page_type_detail': 'user-info',
                    'page_type': 'Function-page',
                    'action_id': "1000601_000",
                    'page_id':"WEB_1000601"
                }
            }
            if (data[pagename]) return data[pagename]
            return {
                'page_type_detail': 'my_account',
                'page_type': 'Function-page',
                'action_id': "1000101_000",
                'page_id':"WEB_1000101"
            }
        },
        'login': () => {
            return {
                'page_type_detail': 'login_in',
                'page_type': 'Function-page',
            }
        },
        'forgottenPassword': () => {
            return {
                'page_type_detail': 'forget_password',
                'page_type': 'Function-page',
            }
        },
        'register': () => {
            return {
                'page_type_detail': 'register',
                'page_type': 'Function-page',
            }
        },
        'my-account': () => { // 废弃
            return {
                'page_type_detail': 'user-info',
                'page_type': 'Function-page',
            }
        },
        'myMemberCard': () => {
            return {
                'page_type_detail': 'member_card',
                'page_type': 'Function-page',
                'page_id': "WEB_1000163",
                'action_id': "1000163_000",
            }
        },
        'restMyCard': () => {
            return {
                'page_type_detail': 'change-card',
                'page_type': 'Function-page',
            }
        },
        'content': () => {
            const content = url.pathname.split('/')[2] || null;
            if (content && content === 'helpinfo') {
                return {
                    'page_type_detail': 'help-center',
                    'page_type': 'Function-page',
                    'page_id': "WEB_1000061",
                    'action_id': "1000061_000",
                }
            }
            if (content && content === 'memberclub') {
                return {
                    'page_type_detail': 'memberclub',
                    'page_type': 'Function-page',
                    'page_id': "WEB_1000161",
                    'action_id': "1000161_000",
                }
            }
            if (content && content === 'card') {
                return {
                    'page_type_detail': 'content_card',
                    'page_type': 'Function-page',
                    'page_id': "WEB_1000164",
                    'action_id': "1000164_000",
                }
            }
            return {
                'page_type_detail': 'content',
                'page_type': 'Function-page',
            }
        },
        'updatePassword': () => {
            return {
                'page_type_detail': 'updatePassword',
                'page_type': 'Function-page',
            }
        },
        'memberLogin': () => {
            return {
                'page_type_detail': 'memberLogin',
                'page_type': 'Function-page',
            }
        },
        'confirmProduct': () => {
            return {
                'page_type_detail': 'confirmProduct',
                'page_type': 'Function-page',
            }
        },
        'campaign': () => {
            const changehistory = url.pathname.split('/')[2] || null;
            if (changehistory && changehistory === 'changehistory') {
                return {
                    'page_type_detail': 'point_redemption_record',
                    'page_type': 'Campaign-page',
                }
            }
            return {
                'page_type_detail': 'campaign_page',
                'page_type': 'Campaign-page',
                'campaign_code': decodeURIComponent(get_campaign_code(url.href))
            }
        },
        'myOrderList': () => {
            return {
                'page_type_detail': 'my_order_list',
                'page_type': 'Function-page',
            }
        },
        'logisticsInfo': () => {
            return {
                'page_type_detail': 'myaccount_logistics',
                'page_type': 'Function-page',
            }
        },
        'wxBindCard': () => {
            return {
                'page_type_detail': 'myaccount_wxBindCard',
                'page_type': 'Function-page',
            }
        },
        'wxChooseCard': () => {
            return {
                'page_type_detail': 'myaccount_wxChooseCard',
                'page_type': 'Function-page',
            }
        },
        'orderPaymentSuccess': () => {
            return {
                'page_type_detail': 'order_paymentSuccess',
                'page_type': 'Function-page',
            }
        },
        'weeklyspecials': () => {
            return {
                'page_type_detail': 'weeklyspecials',
                'page_type': 'Campaign-page',
                'campaign_code': decodeURIComponent(get_campaign_code(url.href))
            }
        },
        'rank': () => {
            return {
                'page_type_detail': 'rank',
                'page_type': 'Campaign-page',
            }
        },
        'error': () => {
            return {
                'page_type_detail': 'error',
                'page_type': 'error',
            }
        },
        'home': () => {
            return {
                'page_type_detail': 'home',
                'page_type': 'home',
            }
        }
    }
    let pathname = url.pathname === '/' ? 'home' : url.pathname.split('/')[1]
    pathname = (pathname.indexOf('order-') === 0) ? 'order' : pathname
    pathname = pathname === 'brands' ? 'brand' : pathname
    const obj = (pathname && pageTMP[pathname] && pageTMP[pathname]()) || {
        'page_type_detail': 'other',
        'page_type': 'other',
    }
    return obj
}


// WEBPACK FOOTER //
// ./common/Utils/Sensor/SensorPageMap.js